export { default } from './Teletriage';
